import { css } from "styled-components";

export const textClip = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
